// Front-end RBAC helpers — mirror backend roles/capabilities.
export const STAFF_ROLES = ["owner", "admin", "tech_support", "management"];

export const ROLE_LABEL = {
    owner: "Owner",
    admin: "Admin",
    tech_support: "Tech Support",
    management: "Management",
    player: "Player",
};

export const isStaff = (user) => !!user && STAFF_ROLES.includes(user.role);

// Backend sends `caps` on the user object; fall back to empty.
export const hasCap = (user, cap) => !!user && Array.isArray(user.caps) && user.caps.includes(cap);
